export default __webpack_public_path__ + "static/media/covid-19-virus.513512da.png";